import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { close, open } from "../redux/popupSlice";
import * as APIS from "../utils/service";
import consts from "../libs/consts"

//가입신청
const GatheringInfo = ({ setStep, setGoDetail, data }) => {
    const dispatch = useDispatch();
    const { configdata } = useSelector(s => s.configReducer);

    const [agree, setAgree] = useState(false);
    const [joinType, setJoinType] = useState(1);
    const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
    const isTablet = useMediaQuery({
        query: "(min-width: 768px) and (max-width: 1024px)",
    });
    const isDesktop = useMediaQuery({ query: "(min-width: 1025px)" });

    const submitJoin = () => {
        if (!agree) {
            dispatch(open({
                component: `이용약관에 동의해주세요.`,
                button: "확인",
                alert: false,
                onPress: () => {
                    dispatch(close());
                }
            }));
            return;
        }

        let sender = {
            idx: data?.idx
        }

        APIS.postData('/v1/communityGroup/join', sender).then(({ data: joinData1 }) => {
            console.log("rrData",joinData1)
            dispatch(open({
                component: joinData1?.message ? joinData1?.message : (
                    <div style={{ textAlign: "center" }}>
                        {data?.title}에 가입신청이
                        완료되었습니다.
                        <br />
                        관리자 승인 후 가입이 완료 됩니다.
                    </div>
                ),
                button: "재신청",
                buttonCencle: "닫기",
                alert: false,
                onCancelPress: () => {
                    dispatch(close());
                    setGoDetail(false);
                    setStep(1);
                }
            }))
        }).catch(({ response }) => {
            const { data: rdata } = response;
            if (rdata?.code === 3) {
                // 거절 재신청 팝
                dispatch(open({
                    component: rdata?.msg || "거절 상태입니다.",
                    title: '알림',
                    button: "재신청하기",
                    buttonCencle: "닫기",
                    alert: false,
                    onPress: () => {
                        sender.retry = true
                        APIS.postData('/v1/communityGroup/join', sender).then(({ data:rrData }) => {
                            console.log("rrData",rrData)
                            dispatch(open({
                                component: rrData?.message ? rrData?.message :(<div style={{ textAlign: "center" }}>
                                    {data?.title}에 가입신청이
                                    완료되었습니다.
                                    <br />
                                    관리자 승인 후 가입이 완료 됩니다.
                                </div>),
                                buttonCencle: "닫기",
                                alert: false,
                                onCancelPress: () => {
                                    dispatch(close());
                                    setGoDetail(false);
                                    setStep(1);
                                }
                            }))
                        }).catch(({ response }) => {
                            const { data: rdata2 } = response;
                            console.log(rdata2);
                        })
                    },
                    onCancelPress: () => {
                        dispatch(close());
                        setGoDetail(false);
                        setStep(1);
                    },
                }))
            } else {
                dispatch(
                    open({
                        component: rdata?.msg || "잠시 후 다시 시도하세요.",
                        title: '알림',
                        button: "확인",
                        titleviewer: true,
                        alert: false,
                        onPress: () => {
                            dispatch(close());
                        },
                    })
                );
            }
        }).finally(() => {
        });



        return;
        // 퍼블작업되었던거
        dispatch(
            open(
                joinType === 1
                    ? {
                        component: (
                            <div style={{ textAlign: "center" }}>
                                {data?.title}에 가입신청이
                                완료되었습니다.
                                <br />
                                관리자 승인 후 가입이 완료 됩니다.
                            </div>
                        ),
                        button: "재신청",
                        buttonCencle: "닫기",
                        alert: false,
                        onCancelPress: () => {
                            dispatch(close());
                            setGoDetail(false);
                            setStep(1);
                        },
                    }
                    : joinType === 2
                        ? {
                            component: `${data?.title}에 가입이 완료되었습니다.`,
                            button: "재신청",
                            buttonCencle: "닫기",
                            alert: false,
                            onCancelPress: () => {
                                dispatch(close());
                                setGoDetail(false);
                                setStep(1);
                            },
                        }
                        : {
                            component: `${data?.title}명에 가입이 거절되었습니다.`,
                            button: "재신청",
                            buttonCencle: "닫기",
                            alert: false,
                            onPress: () => {
                                console.log("??!??");
                            },
                            onCancelPress: () => {
                                dispatch(close());
                            },
                        }
            )
        );
    };

    // 카테고리 이름 변경 
    const cateToName = (type = 1, idx = 1) => {
        if (type === 1) {
            let findCate = configdata?.consts?.communityCategory1?.find(v => v?.idx == idx);
            if (findCate) {
                return findCate?.title
            }
        } else if (type === 2) {
            let findCate = configdata?.consts?.communityCategory2?.find(v => v?.idx == idx);
            if (findCate) {
                return findCate?.title
            }
        }
        return ""
    }

    return (
        <div
            className="community_modal_white_wrap"
            style={{
                justifyContent: "space-between",
                paddingTop: "40px",
            }}
        >
            <div className="gather_info_wrapper">
                <div className="gather_info_wrap">
                    <div className="gather_info_header">
                        <div className="img_wrap">
                            {data?.thumb && <img src={consts.s3url + "/" + data?.thumb} />}
                        </div>
                        <div className="gather_info">
                            <div>
                                {cateToName(1, data?.cate1)}-{cateToName(2, data?.cate2)}
                            </div>
                            <div>{data?.title}</div>
                            <div>{data?.userCount}/{data?.max_count}</div>
                        </div>
                    </div>
                    <div className="gather_content">
                        <p>{data?.desc}</p>
                    </div>
                </div>
            </div>
            <div className="gather_info_wrapper">
                <div>
                    <input
                        type="checkbox"
                        id="agreebtn"
                        className="chkbox_design"
                        onChange={() => setAgree(!agree)}
                        checked={agree}
                    />
                    <label htmlFor="agreebtn">
                        <span onClick={(e) => {
                            e.preventDefault();
                            let sender = {
                                type: 7
                            }
                            APIS.postData('/term', sender).then(({ data }) => {
                                //console.log(data);
                                const PopComponents = () => {
                                    return (
                                        <div
                                            dangerouslySetInnerHTML={{ __html: data }}
                                            className='termContetns'
                                        />
                                    );
                                }
                                dispatch(
                                    open({
                                        component: <PopComponents />,
                                        title: "소모임 이용약관",
                                        titleviewer: true,
                                        alert: false,
                                        alertStyle: {
                                            width: 800
                                        }
                                    })
                                );
                            }).catch((e) => {
                            }).finally(() => {
                            });
                        }}>모두의매물 소모임 이용약관</span>에 동의합니다.
                    </label>
                </div>
                {(!data?.myLink || data?.myLink?.status === 3) && (
                    <div className="bottom_btn_wrap">
                        <button
                            className="register"
                            onClick={submitJoin}
                        // onClick={() => setInnerStep(2)}
                        >
                            {isMobile ? "신청" : "가입신청"}
                        </button>
                        <button
                            className="cancel"
                            onClick={() => {
                                setStep(1);
                                setGoDetail(false);
                            }}
                        >
                            닫기
                        </button>
                    </div>
                )}
                {data?.myLink?.status === 9 && (
                    <>
                        <div className="bottom_btn_wrap">
                            <button className="warn" onClick={() => {
                                submitJoin();
                            }}>{isMobile ? "불가" : "재가입 불가"}</button>
                            <button className="cancel" onClick={() => {
                                setStep(1);
                                setGoDetail(false);
                            }}>닫기</button>
                        </div>
                        <div className="gather_info_bottom">
                            <p>
                                모두의매물은 약관에 위배되는 행위 외 소모임
                                운영에 관여하지 않습니다.
                            </p>
                            <p>재가입 불가 사유는 소모임 관리자에게 문의하세요.</p>
                            <p>
                                ＊ {data?.user?.compony?.title} {data?.user?.name} {data?.user?.rank}
                                {" "}{data?.user?.compony?.company_phone}
                            </p>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default GatheringInfo;
